import { AppDispatch, AppState } from "@/store/configureStore";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { updateCartLocation as updateCartLocationAction } from "@/store/slices/cartSlice";
import toast from "react-hot-toast";

const useUpdateCartLocation = () => {
	const base_url = process.env.NEXT_PUBLIC_BASE_URL;
	const dispatch = useDispatch<AppDispatch>();
	const cart = useSelector((state: AppState) => state.cart);

	const updateCartLocation = async (branchId: string) => {
		if (!cart.id) return;

		const hadDiscount = cart.discountedPrice !== 0;

		try {
			const response = await axios.put(
				`${base_url}/api/cart/${cart.id}/update-cart/${branchId}`
			);

			dispatch(
				updateCartLocationAction({
					id: response?.data?.result?.id,
					totalPrice: response?.data?.result?.totalPrice,
					discountedPrice: response?.data?.result?.discountedPrice,
					items: response?.data?.result?.items,
					applied_promo_code: response?.data?.result?.applied_promo_code,
					initialPrice: response?.data?.result?.initialPrice,
				})
			);

			if (hadDiscount) {
				toast.remove();
				toast.success("Discount removed due to location change");
			}
			// // console.log(response?.data?.result);
		} catch (error: any) {
			// console.error("Error updating cart location:", error);
		}
	};

	return {
		updateCartLocation,
	};
};

export default useUpdateCartLocation;
